import ShareableLinkDataProvider from './ShareableLinkData.provider';

export default ShareableLinkDataProvider;
